import React, {createContext, useContext, useEffect, useState} from 'react';
import {FidgetSpinner, TailSpin} from 'react-loader-spinner';




export const SpinnerContext = createContext({
    isVisible: false,
    showSpinner: () => {
    },
    hideSpinner: () => {
    },
    loading: false,
    setLoading: () => {
    },
});

export const SpinnerProvider = ({children}) => {
    const [isVisible, setIsVisible] = useState(true);
    const [loading, setLoading] = useState(false);
    const showSpinner = () => setIsVisible(true);
    const hideSpinner = () => setIsVisible(false);
    useEffect(() => {
        if (loading) {
            showSpinner();
        } else {
            hideSpinner();
        }
    },[loading])





    return (
        <SpinnerContext.Provider value={{isVisible,loading, setLoading,showSpinner, hideSpinner}}>
            {children}
        </SpinnerContext.Provider>
    );
};
export const useSpinner = () => {
    const context = useContext(SpinnerContext);
    if (context === undefined) {
        throw new Error("Context must be used within a Provider");
    }
    return context;
}
